import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    maskedIban: '{panStart} ···· ···· ···· ···· {panEnd}',
  },
  fr: {
    maskedIban: '{panStart} ···· ···· ···· ···· {panEnd}',
  },
} as const);

export default locales;
